export enum AkeneoSyncEndpoints {
  ROOT = '/akeneo-sync',
  SINGLE_PRODUCT_SYNC = '/single-product-sync',
}

export const staticAkeneoSyncEndpoints = {
  SYNC_PRODUCTS: `${AkeneoSyncEndpoints.ROOT}/products`,
  SYNC_PRODUCTS_MODELS: `${AkeneoSyncEndpoints.ROOT}/product-models`,
  SYNC_ENTITY: `${AkeneoSyncEndpoints.ROOT}/sync-entity`,
  GET_ENTITIES_INFO: `${AkeneoSyncEndpoints.ROOT}/entities-info`,
  CLEAN_SYNC: `${AkeneoSyncEndpoints.ROOT}/clean-sync`,
  PRODUCT_SYNC_RESULTS: `${AkeneoSyncEndpoints.ROOT}/product-sync-results`,
  GET_CLEAN_UP_DATA: `${AkeneoSyncEndpoints.ROOT}/clean-sync`,
  SYNC_SINGLE_PRODUCT: `${AkeneoSyncEndpoints.ROOT}${AkeneoSyncEndpoints.SINGLE_PRODUCT_SYNC}`,
};

export const getSyncEndpoints = ({ type }: { type: string }) => ({
  SYNC_BY_ENTITY: `${AkeneoSyncEndpoints.ROOT}/${type}`,
});

export enum EntityTypes {
  MEASUREMENTS = 'measurements',
  ASSOCIATION_TYPES = 'association_types',
  CATEGORIES = 'categories',
  ATTRIBUTES = 'attributes',
  FAMILIES = 'families',
}

export type IEntityInfo = {
  id: string;
  entityType: EntityTypes;
  status: string;
  createdAt: string;
  updatedAt: string;
};

export interface IProductSync {
  totalPlanned: number;
  totalSucceeded: number;
  totalFailed: number;
  type: string;
  status: string;
  channelSlugs: string[];
  transactionId: string;
  timeStart: string;
  error?: string | null;
  productSku?: string | null;
}

export interface ICleanupDataItem {
  id: string;
  jobId: string;
  channelSlug: string;
  akeneoCount: number;
  localCount: number;
  candidatesToDelete: number;
  failedCount: number;
  iteratedCount: number;
  deletedCount: number;
  status: string;
  error: null | string;
  createdAt: string;
  updatedAt: string;
}

// ============== DTO ==============

export interface IBaseAkeneoSyncDTO {
  channelSlugs: string[];
  updatedFrom: string;
  updatedUntil: string;
}

export type IAkeneoSyncProductsDTO = IBaseAkeneoSyncDTO & {
  type: string;
};

export type IAkeneoSyncSpecificProductDTO = {
  channelSlug: string;
  sku: string;
};

export type IAkeneoCleanSyncDTO = {
  channelSlug: string;
};

export type IAkeneoSyncEntityDTO = {
  entityTypes: EntityTypes[];
};

// ============== Response ==============

export interface IBaseAkeneoSyncResponse {
  success: boolean;
}

export type IGetEntitiesInfoResponse = Record<
  EntityTypes,
  {
    id: string;
    entityType: EntityTypes;
    status: string;
    createdAt: string;
    updatedAt: string;
  }
>;

export interface IProductSyncResponse {
  records: IProductSync[];
}

export type IGetCleanupDatabaseDataResponse = ICleanupDataItem[];
